import React, { useState } from 'react';
import Form from './Form';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { useEntityCrud } from '../../hooks/useEntityCrud';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import moment from 'moment-jalali';

const initialValues = {
 
};
 

const validationSchema = Yup.object({
 
});

const Create = () => {

    const { addData } = useEntityCrud('OpinionFactor/SetOpinionFactor');
    const navigate = useNavigate();

    const onSubmit = (values) => {
         
        document.getElementById('btn-submit-form').classList.add('btn-loading');
        const postedData = {
            "title": values.title,
            "status": true
        };
        addData(postedData).then(({ data }) => {
             
            if (data.status) {
                toast.success('معیار جدید با موفقیت ایجاد شد');
                return navigate('/surveyCriterias');
            }
            else
                data.errors.map(error => toast.error(error.message));
        }).finally(() => document.getElementById('btn-submit-form').classList.remove('btn-loading'));

    }


    const formik = useFormik({
        initialValues: initialValues,
        onSubmit,
        validationSchema: validationSchema
    });

    const handleBack = () => {
        navigate('/surveyCriterias', { replace: true });
    }




    return (
        <div className="card">
            <div className="card-header d-flex justify-content-between">
                <div className="card-title">ایجاد امتیاز جدید</div>
                <a className="backIconLink" onClick={handleBack}><i className="fa fa-arrow-left" title="بازگشت"></i></a>
            </div>
            <div className="card-body">
                <Form formik={formik}  />
            </div>
        </div>
    );
}

export default Create;